import { createTheme } from '@mui/material/styles';
import { presetPalettes } from '@ant-design/colors';
import ThemeOption from 'themes/theme/theme.ts';
import { PaletteMode } from '@mui/material';
import { darkTokens, lightTokens } from 'themes/tokens';

const Palette = (mode: PaletteMode) => {
  const colors = presetPalettes;

  const greyPrimary = [
    '#ffffff',
    '#fafafa',
    '#f5f5f5',
    '#f0f0f0',
    '#d9d9d9',
    '#bfbfbf',
    '#8c8c8c',
    '#595959',
    '#262626',
    '#141414',
    '#000000',
  ];
  const greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];
  const greyConstant = ['#fafafb', '#e6ebf1'];

  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

  const paletteColor = ThemeOption(colors as unknown as Record<string, string>);

  const tokens = mode === 'light' ? lightTokens : darkTokens;

  return createTheme({
    palette: {
      mode,
      common: {
        black: '#000',
        white: '#fff',
      },
      ...paletteColor,
      accent: {
        ...paletteColor.accent,
        main: tokens.accent.main,
        contrastText: tokens.accent.contrastText,
      },
      text: {
        primary: tokens.text.primary,
        secondary: tokens.text.secondary,
        disabled: tokens.text.disabled,
      },
      action: {
        disabled: tokens.actionDisabled,
      },
      divider: tokens.divider,
      background: {
        paper: tokens.background.paper,
        default: tokens.background.default,
      },
    },
  });
};

export default Palette;
